import React, { useState } from 'react'
import { Modal, Box } from '@material-ui/core'
import { NewsHeaderCard } from 'react-ui-cards'
import imageLinks from '../../assets/imageLinks.json'
import './Graphics.scss'

const Graphics = () => {
    const [open, setOpen ] = useState(false)
    const [src, setSource] = useState(null)
    const handleOpen = img => {
        setSource(img.thumbnail)
        setOpen(true)
    }
    const handleClose = () => setOpen(false)
    const { images } = imageLinks
    return (
        <div id='graphics-pane'>
            <Modal
                open={ open }
                onClose={ handleClose }
            >
                <Box style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    // width: 400,
                    bgcolor: 'background.paper',
                    border: '2px solid #000',
                    boxShadow: 24,
                    p: 4 }}>
                    <div>
                        <img src={src} style={{ height: '475px' }}/>
                    </div>
                </Box>
            </Modal>
            <h2>Graphics</h2>
            <div className='styles__card-container'>
                {
                    images.map(o => (
                        <div style={{ margin: '20px 00px 20px 20px'}}>
                            <NewsHeaderCard
                                thumbnail = { o.thumbnail }
                                title = { o.title }
                                onClick={ () => handleOpen(o) }
                            />
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default Graphics
